/*eslint-disable */

import axios from 'axios';
import moment from 'moment';
import root from '@/_helpers/roots';

const $ = window.jQuery = require('jquery'); 
let modelFiltersApiUrl = root.mostUsedTrainModelForAiDashApiUrl.link;
export default {
  name: 'recently-used-models',
  components: {
  },
  props: [],
  data () {
    return {
      createdAlgoList:null,
      createdAlgoListResults:[],
      pubModelId:'',
      publicModelPopup:false,
      userDetails:null,
      updateModelName:'',
      updateModelNameId:'',
      updateModelNameState:false,
      sharedModelInfo:null,
      sharedModelPopup:false,
      submitted:false,
      algoListForClassification:[
        'Logistic Regression',
        'Decision Tree Classifier',
        'Random Forest Classifier',
        'Gradient Boosting Classifier',
        'Support Vector Classifier',
        'Gaussian Naive Bias',
        'K-Neighbors Classifier'
      ],
      algoListForRegression:[
        'Linear Regression',
        'Decision Tree Regressor',
        'Random Forest Regressor',
        'Gradient Boosting Regressor',
        'Support Vector Regressor',
        'K-Neighbors Regressor'
      ],
      is_type:'',
      is_algorithm:'',
      is_disease:'',
      is_year:'',
      is_month:'',
      is_month_name:'',
      diseaseListResults:[],
      userLoading:false,
      isSelectedAlgoData:[],
      filterEnabledState:false
    }
  },
  computed: {
  },
  mounted () {
    this.getCreatedModelsListFunc();
    this.$store.dispatch('getDiseaseListForAiDashFun').then((res) => {
      this.diseaseListResults = res.data.data.results
    })
  },
  methods: {
    clearFiltersMethod(){
      this.filterEnabledState = false
      this.is_type = '' 
      this.is_algorithm = ''
      this.is_disease = ''
      this.is_year = ''
      this.is_month_name = ''
      this.is_month = ''
      this.userLoading = true
      this.$store.dispatch('getMostUsedTrainModelForAiDashFun').then((res) => {
        this.createdAlgoList = res.data.data
        this.createdAlgoListResults = this.createdAlgoList.results 
        this.userLoading = false
      }).catch((err) => {
        this.userLoading = false
      })
    },
    filterByIsTypeMethod(val){
      this.filterEnabledState = true
      this.is_type = val
      this.userLoading = true
      if(val == 'classification'){
        this.isSelectedAlgoData = this.algoListForClassification
      }else{
        this.isSelectedAlgoData = this.algoListForRegression
      }
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.createdAlgoList = response.data.data
        this.createdAlgoListResults = this.createdAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsAlgoMethod(val){
      this.filterEnabledState = true
      this.is_algorithm = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.createdAlgoList = response.data.data
        this.createdAlgoListResults = this.createdAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsDiseaseMethod(val){
      this.filterEnabledState = true
      this.is_disease = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.createdAlgoList = response.data.data
        this.createdAlgoListResults = this.createdAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsYearMethod(val){
      this.filterEnabledState = true
      this.is_year = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.createdAlgoList = response.data.data
        this.createdAlgoListResults = this.createdAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsMonthMethod(name, val){
      this.filterEnabledState = true
      this.is_month_name = name
      this.is_month = val
      this.userLoading = true
      const is_year = this.is_year || moment(new Date()).format('YYYY')
      axios.get(modelFiltersApiUrl + '?is_year=' + is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.createdAlgoList = response.data.data
        this.createdAlgoListResults = this.createdAlgoList.results
        this.userLoading = false
      })
    },
    getCreatedModelsListFunc() {
      this.$store.dispatch('getMostUsedTrainModelForAiDashFun').then((res) => {
        this.createdAlgoList = res.data.data
        this.createdAlgoListResults = this.createdAlgoList.results 
      })
    },
  },
  watch:{
  }
}